import React from 'react';
import { InfinitySpin } from  'react-loader-spinner'

function Loading() {
  return (
    <div style={{display:'flex', justifyContent:'center'}}>
        <InfinitySpin 
        width='200'
        color="#4fa94d"
/>
    </div>
  )
}

export default Loading